import React from 'react';
import { useNavigate } from 'react-router-dom';
import useCalendarEntitlement from '../../hooks/useCalendarEntitlement';

function ToolsHub() {
  const navigate = useNavigate();
  const calendar = useCalendarEntitlement();

  return (
    <div className="admin-dashboard-container">
      {/* Header with Back Button */}
      <div className="admin-hub-header">
        <button
          onClick={() => navigate('/admin')}
          className="admin-hub-back-btn"
        >
          <span className="admin-hub-back-arrow">←</span>
          Back to Dashboard
        </button>
        <h1 className="admin-page-title">Tools</h1>
        <p className="admin-hub-subtitle">eBay integrations, property sourcing, and auction management</p>
      </div>

      {/* Hub Cards Grid */}
      <div className="admin-hub-grid">
        <div className="card admin-menu-card" onClick={() => navigate('/admin/ebay-listing-generator')}>
          <div className="admin-hub-card-icon">📦</div>
          <h2>eBay Listing Generator</h2>
          <p>Generate professional eBay listings with payment calculations. Create compelling auction descriptions quickly.</p>
          <button className="btn btn-primary">Generate Listing</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/ebay-submissions')}>
          <div className="admin-hub-card-icon">🏆</div>
          <h2>eBay Auction Winners</h2>
          <p>Manage auction winner submissions and convert them to customers. Track winning bids and buyer information.</p>
          <button className="btn btn-primary">View Submissions</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/property-sources')}>
          <div className="admin-hub-card-icon">🗂️</div>
          <h2>Property Sources</h2>
          <p>Track auction sites, login credentials, and property acquisition sources. Manage your sourcing pipeline.</p>
          <button className="btn btn-primary">Manage Sources</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/auction-calendar')}>
          <div className="admin-hub-card-icon">📅</div>
          <h2>My Auction List</h2>
          <p>Track the auction dates you mean to attend and the properties you are watching. Your own list, private to you.</p>
          <button className="btn btn-primary">View My List</button>
        </div>

        {/*
          The PLATFORM calendar, shown only when the tenant's plan includes it.
          `ready` is checked so an entitled tenant does not see the card appear
          a moment after the page settles.

          Hiding it is a courtesy, not the control. /admin/calendar is gated on
          the server, so a tenant who reaches the URL anyway gets the upgrade
          page rather than the data.
        */}
        {calendar.ready && calendar.included && (
          <div className="card admin-menu-card" onClick={() => navigate('/admin/calendar')}>
            <div className="admin-hub-card-icon">🗺️</div>
            <h2>Auction Calendar</h2>
            <p>County by county tax deed and tax lien sale dates across every live state, kept current by hand.</p>
            <button className="btn btn-primary">Open Calendar</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ToolsHub;
